import lifeAndIncomeContent from './life-and-income';

const CONTENT = {
  'income-protection': lifeAndIncomeContent,
  life: lifeAndIncomeContent,
};

export default CONTENT;
